module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-manage-f82fac83790e54783d17e3cbe2b9df5b.svg";